import { connect } from 'react-redux'
import Events from './Events.component'
import * as Actions from 'state/actions'

const mapStateToProps = state => {
  return {
    chartType: state.analyticsOpeningEvents.chartType,
    granularity: state.analyticsOpeningEvents.granularity,
    dateRange: state.analyticsOpeningEvents.dateRange,
    customDateRange: state.analyticsOpeningEvents.customDateRange,
    channelNameToFilter: state.analyticsOpeningEvents.channelNameToFilter
  }
}

const mapDispatchToProps = dispatch => {
  return {
    onChangeChartType: chartType => () => dispatch(Actions.openingEventsChangeField('chartType', chartType)),
    onChangeGranularity: granularity => () => dispatch(Actions.openingEventsChangeField('granularity', granularity)),
    onMoveCustomDateRange: operation => () => dispatch(Actions.openingEventsMoveCustomDateRange(operation)),
    onChangeSelectField: field => e => dispatch(Actions.openingEventsChangeField(field, e.target.value)),
    onChangeCustomDateRange: ({ startDate, endDate }) => dispatch(Actions.openingEventsChangeDateRange(startDate, endDate))
  }
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(Events)
